import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import styles from './Dropdown.module.css';

const Dropdown = ({
  options = [],
  value,
  onChange,
  placeholder = 'Select an option',
  icon: Icon,
  error,
  label,
  disabled = false,
  getOptionLabel = (option) => option.name || option,
  getOptionValue = (option) => option.id || option,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelectOption = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const selectedLabel = value ? getOptionLabel(value) : placeholder;

  return (
    <div className={styles.container} ref={containerRef}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.wrapper}>
        {Icon && <Icon className={styles.icon} size={18} />}
        <button
          type="button"
          className={`${styles.button} ${Icon ? styles.padLeft : ''} ${error ? styles.error : ''}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
          disabled={disabled}
          aria-label={label}
        >
          <span className={!value ? styles.placeholder : ''}>{selectedLabel}</span>
          <ChevronDown 
            className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`} 
            size={16} 
          />
        </button>
      </div>

      {isOpen && options.length > 0 && (
        <div className={styles.dropdown}>
          {options.map((option, index) => (
            <div
              key={index}
              className={`${styles.option} ${
                value && getOptionValue(value) === getOptionValue(option) ? styles.selected : ''
              }`}
              onClick={() => handleSelectOption(option)}
            >
              {getOptionLabel(option)}
            </div>
          ))}
        </div>
      )}

      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

export default Dropdown;
